import dynamicAPI from './dynamicAPI';
import { useMutation, useQuery } from 'react-query';
import { useMessage } from '../context/AdminMessageContext';

const base = '/api/auth/invites';

export default function usePublicUserInvitesHook() {
    const { setSuccessMessage, setErrorMessage } = useMessage();

    // PUBLIC: validate token (must be a hook -> name starts with "use")
    const useValidateInviteToken = (token) =>
        useQuery(
            ['invite-validate', token],
            async () => {
                const res = await dynamicAPI('get', `${base}/validate/${token}`);
                if (res?.error) throw new Error(res.error);
                return res;
            },
            { retry: 0, enabled: !!token }
        );

    // PUBLIC: register with invite
    // NOTE: backend route is /api/auth/register-invite (NOT under /invites)
    const registerWithInvite = useMutation(
        async ({ token, name, email, password }) =>
            await dynamicAPI('post', `/api/auth/register-invite`, {
                token,
                name,
                email,
                password,
            }),
        {
            retry: 0,
            onSuccess: () => setSuccessMessage('Registration submitted. Awaiting approval.'),
            onError: (error) => setErrorMessage(error?.error || 'Registration failed.'),
        }
    );

    return {
        useValidateInviteToken,
        registerWithInvite,
    };
}
